import { lazy } from 'react'

/**
 * Wraps React.lazy to add a preload method that can be called to load
 * the component before it's needed (e.g., on hover over navigation).
 *
 * This enables progressive enhancement - hover prefetching makes navigation
 * feel instant, while useTransition ensures no blank screens as fallback.
 *
 * @param {Function} importFunc - Dynamic import function (e.g., () => import('./Component'))
 * @returns {React.LazyExoticComponent} Lazy component with added preload() method
 *
 * @example
 * const Board = lazyWithPreload(() => import('./pages/Board'))
 *
 * // Later, on hover or predictive loading:
 * Board.preload() // Starts loading the chunk immediately
 *
 * // When navigating, component is likely already loaded:
 * <Route path="/board" element={<Board />} />
 */
export function lazyWithPreload(importFunc) {
  const LazyComponent = lazy(importFunc)
  LazyComponent.preload = importFunc
  return LazyComponent
}
